import { Component, Input } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { OrderService, AuthenticationService } from '@app/_services';
import { ToastrService } from 'ngx-toastr';
import { Payments } from '@app/_models';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { BenefitPayDialogComponent } from '@app/shared/components/benefit-pay-dialog/benefit-pay-dialog.component';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { TranslateHelper } from '@app/_helpers';
import * as _ from 'lodash';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { professionalOrderDetailsComponent } from './component/professional-order-details/professional-order-details.component';
import { PageVendorOrderDetailsComponent } from './component/order-details/order-details.component';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-page-order-details-parent',
    templateUrl: './page-order-details.component.html',
    styleUrls: ['./page-order-details.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [NgIf, PageVendorOrderDetailsComponent, professionalOrderDetailsComponent, RouterLink, TranslateModule]
})
export class PageOrderDetailsParentComponent {
    constructor(private route: ActivatedRoute,
        private toastr: ToastrService,
        private dialog: MatDialog,
        private modalService: BsModalService,
        public translate: TranslateService,
        public translateHelper: TranslateHelper,
        private ordersService: OrderService) { }

    order;
    type
    orderId;
    bsModalRef: BsModalRef;
    loading = false;

    ngOnInit(): void {
        this.loading = true;
         this.route.params.subscribe((params) => {
            this.orderId = params['orderId'];
            this.ordersService.getOrderById(this.orderId).subscribe((response)=>{
                if (response.code == 200) {
                    this.order = response.data;
                    this.type = response.data.type;
                } else {
                    this.loading = false;
                }
            }, (error)=>{
                this.loading = false;
            })
        });
    }
}
